export default __webpack_public_path__ + "static/media/idleGhostKid.4c86c4d7.gif";